module.exports = __webpack_public_path__ + "img/zhu_zc_songlei.6922ad01.jpg";